<template>
  <div class="bg-profile max-w-main" style="min-height: calc(100vh - 51px);">
    <div class="p-1" >
        <img @click="toHomePage" class="ml-8 h-8" src="../../assets/logo_web.png" >
    </div>
    <div class="mt-3 p-3 color-main font-main">        
        <div>
            <!-- <div class="font-bold text-lg text-center mt-4 w-3/4 m-auto">
                BẠN CẦN CUNG CẤP THÊM THÔNG TIN ĐỂ TIẾP TỤC
            </div> -->
            <!-- <div class="text-center text-black" style="font-family: arial;">
                Chúng tôi sẽ tiếp tục tìm kiếm trong thời gian tới
            </div> -->
            <div class=" font-bold">
                Thông tin CMND/ CCCD
            </div>
            <div class="grid grid-cols-2 gap-4 text-center text-xs color-main font-semibold">
                <div @click="select_file1" class="border-cmnd w-100 bg-white align-middle">
                    <img class="m-auto align-middle pt-3" :src="src1" >
                    <div class="opacity-40 mt-1"><span v-if="!isUpload"> mặt trước </span> <b-spinner v-else variant="primary" label=""></b-spinner> </div>
                    
                </div>
                <div @click="select_file2" class="border-cmnd w-100 bg-white align-middle">
                    <img class="m-auto align-middle pt-3" :src="src2" >
                    <div class="opacity-40 mt-1"><span v-if="!isUpload"> mặt sau </span> <b-spinner v-else variant="primary" label=""></b-spinner></div>
                </div>
            </div>
            <div>
                <input id="fileUpload1" @change="uploadFile1" ref="fileUpload1" class="hidden" type="file">
                <input id="fileUpload2" @change="uploadFile2" ref="fileUpload2" class="hidden" type="file">
            </div>
            <div class="mt-4">
                <div class="grid grid-cols-3 gap-4 mt-3">
                    <div class="text-xs font-bold">
                        Họ và tên:
                    </div>
                    <div class="col-span-2">
                        <input v-model="form.fullname" class="w-full rounded-sm shadow-input focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent pl-1" />
                    </div>
                </div>

                <div class="grid grid-cols-3 gap-4 mt-3">
                    <div class="font-bold text-xs">
                        Số CMND/ CCCD:
                    </div>
                    <div class="col-span-2">
                        <input v-model="form.identity_card" class="w-full rounded-sm shadow-input focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent pl-1" />
                    </div>
                </div>

                <div class="grid grid-cols-3 gap-4 mt-3">
                    <div class="font-bold text-xs">
                        Ngày cấp:
                    </div>
                    <div class="col-span-2">
                        <input v-model="form.issued_on" type="date" class="w-full rounded-sm shadow-input focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent pl-1" />
                    </div>
                </div>

                <div class="grid grid-cols-3 gap-4 mt-3">
                    <div class="font-bold text-xs">
                        Nơi cấp:
                    </div>
                    <div class="col-span-2">
                        <input v-model="form.identity_card_place" class="w-full rounded-sm shadow-input focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent pl-1" />
                    </div>
                </div>

                <div class="grid grid-cols-3 gap-4 mt-3">
                    <div class="font-bold text-xs">
                        Giới tính:
                    </div>
                    <div class="col-span-1">
                        <input type="radio" id="male" v-model="form.gender" name="gender" value="1">
                        <label class="ml-2" for="html">Nam</label><br>
                        
                    </div>
                    <div class="col-span-1">
                        <input type="radio" id="female" v-model="form.gender" name="gender" value="0">
                        <label class="ml-2" for="html">Nữ</label><br>
                        
                    </div>
                </div>

                <div class="grid grid-cols-3 gap-4 mt-3">
                    <div class="font-bold text-xs">
                        Ngày sinh:
                    </div>
                    <div class="col-span-2">
                        <input type="date" v-model="form.dob" class="w-full rounded-sm shadow-input focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent pl-1" />
                    </div>
                </div>
            </div>
            <div class="mt-5 text-center">
                <button @click="saveInfo" class="bg-main text-white font-bold rounded-md m-auto" style="box-shadow: 4px 3px 5px rgba(100, 21, 95, 0.34); height: 31px; width: 261px;"> Lưu lại thông tin </button>
            </div>
        </div>
        <div class="mt-4 text-center">
            <div @click="toHomePage" class="mt-3 color-main2 font-bold">
                Trở về trang chủ
            </div>
        </div>

        <!-- <div class=" mt-4">
            <tima-register />
        </div> -->
    </div>

    <b-modal hide-header hide-footer centered id="modal-tima">
        <tima-register />
    </b-modal>
  </div>
</template>

<script>
import { sendFile,saveCustomer,getInforKyc } from '@/api/otp'
import {getPartner,getMoney,getLogo,getToken} from '@/utils/auth'
import TimaRegister from '../components/tima_register.vue'
import ResultSuccess from '../components/result_success.vue'
import ListPartner from '../components/list_partner.vue'
import subRoute from '@/router/subRoute'
import router from "@/router";

export default {
    components: {
        TimaRegister,
        ResultSuccess,
        ListPartner
    },
    data() {
        return {
            form: {
                fullname: '',
                identity_card: '',
                issued_on: '',
                identity_card_place: '',
                identity_card_date: '',
                gender: null,
                dob: ''
            },
            isUpload: false,
            file1: '',
            file2: '',
            money: getMoney(),
            partner: getPartner(),
            logo: getLogo(),
            src1: '@/assets/default/camera.png',
            src2: '@/assets/default/camera.png',
        }
    },
    created() {
        this.fetchEkyc()
        if(!getToken()){
            this.$router.push('/')
        }
    },
    methods: {
        fetchEkyc(){
            getInforKyc({}).then(res =>{
                this.form = res.data
                this.src1 = res.data.identity_url_front_view ? res.data.identity_url_front_view : '@/assets/default/camera.png'
                this.src2 = res.data.identity_url_back_view ? res.data.identity_url_back_view : '@/assets/default/camera.png'

            })
        },
        toHomePage (){
            let r = subRoute
            this.$router.push(r)
        },
        select_file1(){
             document.getElementById("fileUpload1").click()
        },
        select_file2(){
             document.getElementById("fileUpload2").click()
        },
        uploadFile1(event) {
            this.file1 = event.target.files[0];
            this.src1 = URL.createObjectURL(this.file1);
            if(this.file1 && this.file2){
                this.submitFile()
            }
        },
        uploadFile2(event) {
            this.file2 = event.target.files[0];
            this.src2 = URL.createObjectURL(this.file2);
            if(this.file1 && this.file2){
                this.submitFile()
            }
        },
        saveInfo(){
            this.form.identity_card_date = this.form.issued_on
            saveCustomer(this.form).then(res => {
                if(res.status == 200 || res.status == 0){
                    this.$bvModal.show('modal-tima')
                    // this.$bvModal._root.$children[0].modal = {
                    //     title: 'Cảm ơn bạn đã để lại thông tin',
                    //     content: 'Đối tác giải ngân sẽ liên hệ hỗ trợ bạn trong 24h tới. Gọi số 1900633337 nếu bạn chưa được liên hệ.',
                    //     btnHome: true
                    // }
                    // this.$bvModal.show('modal-notify')
                    // this.$bvToast.toast('Lưu thông tin thành công', {
                    //         title: 'Thành công',
                    //         variant: 'success',
                    //         solid: true
                    //     })
                }
            })
        },
        submitFile(){
            this.isUpload = true
            let obj = {
                file_img1: this.file1,
                file_img2: this.file2,
            }
            sendFile(obj).then(res => {
                if(res.status == 200){
                    this.form = res.data
                    this.isUpload = false
                } else {
                    this.$bvToast.toast('Hình ảnh không hợp lệ, xin quý khách vui lòng chụp lại hình', {
                            title: 'Có lỗi xảy ra',
                            variant: 'danger',
                            solid: true
                        })
                    this.isUpload = false
                }
                            })
        },
    },
    // head: {
    //     script: [
    //         { type: 'text/javascript', src: window.location.origin + router.options.base + '/script/ekyc_page.js'},
    //         { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=AW-10851243888' ,  async: true,},
    //     ],
    //     noscript: [
    //         {
    //             inner: '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1361189891010235&ev=PageView&noscript=1"/>'
    //         }
    //     ]
    // }
}
</script>

<style>

</style>